<template>
  <section class="naming-signs">
    <h2 class="text-h6 mb-4">Signage Logic</h2>
    <p>Level one</p>
    <v-row>
      <v-col :cols="4" class="namimg-sign">
        <div class="parent-sign--unit mb-10">
          <ul>
            <li v-for="item in doc.list" :key="`logo-${item.name}-${id}`">
              <h1 class="text-h5">{{ item.title }}</h1>
            </li>
          </ul>
        </div>
      </v-col>
    </v-row>
    <p>Level two</p>
    <v-row>
      <v-col
        v-for="(item, index) in doc.list"
        :key="`logo-${item.name}-${id}-${index}`"
        :cols="getCols"
        class="namimg-sign"
      >
        <div class="sub-sign--unit">
          <h2 class="text-p">{{ item.title }}</h2>
          <ul>
            <li
              v-for="(child, index) in item.children"
              :key="`child-${child.name}-${id}-${index}`"
              class=""
            >
              <p class="text-p">{{ getName(child) }}</p>
            </li>
          </ul>
        </div>

        <div
          v-for="(featured, index) in collectFeatured(item)"
          :key="`featured-${featured.name}-${index}`"
          class="featured-sign--unit"
        >
          <ul>
            <li class="text-p">{{ featured.name }}</li>
          </ul>
        </div>
      </v-col>
    </v-row>

    <p>Level three</p>

    <v-row>
      <v-col
        v-for="item in doc.list"
        :key="`logo-${item.name}-${id}`"
        :cols="getCols"
        class="namimg-sign"
      >
        <div>
          <template v-for="child in item.children">
            <div
              class="third-sign--unit"
              :key="`holder-${child.name}-${child.id}`"
            >
              <h2 class="text-p">{{ getName(child) }}</h2>
              <ul>
                <template v-for="sub in child.children">
                  <li :key="`third-${sub.name}-${id}-${sub.id}`">
                    <p class="text-p">{{ getName(sub) }}</p>
                  </li>
                </template>
              </ul>
            </div>
          </template>
        </div>
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  name: "NamingLogos",
  data() {
    return {};
  },
  props: {
    cols: {
      type: Number,
      default: 4,
    },
    id: {
      type: String,
      default: "diushoaidcs",
    },
    doc: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  computed: {
    getCols() {
      if (this.doc.listNames) {
        const l = this.doc.listNames.length;
        switch (l) {
          case 1:
            return 12;
          case 2:
            return 6;
          case 3:
            return 4;
          case 4:
            return 3;
          default:
            return 4;
        }
      } else {
        return 12;
      }
    },
  },
  methods: {
    collectFeatured(item) {
      const arr = [];
      item.children.forEach((x) => {
        if (x.children && x.children.length) {
          x.children.forEach((y) => {
            if (y.spotlight && y.spotlight === true) {
              arr.push(y);
            }
          });
        }
      });
      return arr;
    },
    getColor(col) {
      switch (col) {
        case 0:
          return "#009688";
        case 1:
          return "#F44336";
        case 2:
          return "#673AB7";
        case 3:
          return "#1B5E20";
        case 4:
          return "#2196F3";
        default:
          return "#E91E63";
      }
    },
    getName(el) {
      if (this.doc.prefix && el.allowPrefix) {
        switch (this.doc.prefixPosition) {
          case "after":
            return `${el.name}${this.doc.prefix}`;
          case "after-space":
            return `${el.name} ${this.doc.prefix}`;
          case "before":
            return `${this.doc.prefix}${el.name}`;
          case "before-space":
            return `${this.doc.prefix} ${el.name}`;
        }
      } else {
        return el.name;
      }
    },
  },
};
</script>

<style lang="scss"></style>
